import * as React from "react";
import { SVGProps } from "react";
export const ArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.04201 16.042L3.60401 10.625C3.50667 10.5277 3.43734 10.427 3.39601 10.323C3.35401 10.219 3.33301 10.1113 3.33301 10C3.33301 9.88867 3.35401 9.781 3.39601 9.677C3.43734 9.573 3.50667 9.47233 3.60401 9.375L9.04201 3.938C9.20867 3.77133 9.41001 3.68433 9.64601 3.677C9.88201 3.67033 10.0903 3.75733 10.271 3.938C10.4377 4.10467 10.521 4.30933 10.521 4.552C10.521 4.79533 10.4377 5.00033 10.271 5.167L6.31201 9.125H15.438C15.674 9.125 15.8787 9.21167 16.052 9.385C16.2253 9.559 16.312 9.764 16.312 10C16.312 10.236 16.2253 10.441 16.052 10.615C15.8787 10.7883 15.674 10.875 15.438 10.875H6.31201L10.271 14.833C10.4377 14.9997 10.5243 15.1977 10.531 15.427C10.5383 15.6563 10.4517 15.8613 10.271 16.042C10.1043 16.2087 9.89934 16.292 9.65601 16.292C9.41334 16.292 9.20867 16.2087 9.04201 16.042Z"
            fill="currentColor"
        />
    </svg>
);
ArrowLeftIcon.displayName = "ArrowLeftIcon";
